var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-collapse",
        { attrs: { visible: !_vm.canCompute } },
        [
          _vm.canCompute === false
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "12" } },
                    [
                      _c(
                        "b-alert",
                        { attrs: { show: "", variant: "warning" } },
                        [
                          _c(_vm.getLucideIcon("AlertTriangle"), {
                            tag: "component",
                            attrs: { size: 16 },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.FormMSG(
                                  89,
                                  "This transport mean type is not computed by Google"
                                )
                              ) +
                              "\n\t\t\t\t"
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { sm: "12", md: 4, lg: 4, xl: 4 } },
            [
              _c(
                "b-form-group",
                { attrs: { label: _vm.FormMSG(1954, "Production phase") } },
                [
                  _c("b-form-select", {
                    class: { "bg-color-grams-hair": _vm.disableAll },
                    attrs: {
                      options: _vm.productionPhaseOptions,
                      disabled: _vm.disableForms || _vm.disableAll,
                    },
                    on: { change: _vm.handleChangeProductionPhase },
                    model: {
                      value: _vm.dataToSend.productionPhase,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataToSend, "productionPhase", $$v)
                      },
                      expression: "dataToSend.productionPhase",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { sm: "12", md: 4, lg: 4, xl: 4 } },
            [
              _c(
                "b-form-group",
                { attrs: { label: _vm.FormMSG(45, "Vehicle") } },
                [
                  _c("v-select", {
                    attrs: {
                      label: "name",
                      options: _vm.vehicules,
                      placeholder: _vm.FormMSG(85, "Please select"),
                      reduce: (option) => +option.id,
                      clearable: false,
                      disabled: _vm.disableForms || _vm.disableAll,
                    },
                    on: { input: _vm.handleInputVehiculeId },
                    model: {
                      value: _vm.dataToSend.vehiculeId,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataToSend, "vehiculeId", $$v)
                      },
                      expression: "dataToSend.vehiculeId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { sm: "12", md: 4, lg: 4, xl: 4 } },
            [
              _c(
                "b-form-group",
                { attrs: { label: _vm.FormMSG(17, "Number of vehicle") } },
                [
                  _c("b-form-input", {
                    class: { "bg-color-grams-hair": _vm.disableForms },
                    attrs: { disabled: _vm.disableForms || _vm.disableAll },
                    on: { change: _vm.handleChangeNumberVehicle },
                    model: {
                      value: _vm.dataToSend.numberOfVehicule,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataToSend, "numberOfVehicule", $$v)
                      },
                      expression: "dataToSend.numberOfVehicule",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.hideTransportTypeSelector === false
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { sm: "12", md: 12, lg: 12, xl: 12 } },
                [
                  _c("transport-type-selector", {
                    ref: "transportTypSelectorCoTwo",
                    attrs: {
                      "data-additional-detail":
                        _vm.dataToSend.additionalSubType,
                      "data-detail": _vm.dataToSend.subType,
                      "data-type": _vm.dataToSend.type,
                      "data-special-equipment":
                        _vm.dataToSend.specialEquipmentId,
                      "disable-form": _vm.disableForms || _vm.disableAll,
                    },
                    on: {
                      "transportation-type-selector:change":
                        _vm.handleTransportationTypeSelectorChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.$screen.width <= 576 && _vm.hideDistanceKnown === false
        ? _c(
            "b-row",
            { staticClass: "mt-2 mb-3" },
            [
              _c(
                "b-col",
                { attrs: { sm: "12" } },
                [
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: {
                        size: "lg",
                        disabled: _vm.disableForms || _vm.disableAll,
                        switch: "",
                      },
                      model: {
                        value: _vm.dataToSend.distanceKnown,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataToSend, "distanceKnown", $$v)
                        },
                        expression: "dataToSend.distanceKnown",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center fs-14" },
                        [_vm._v(_vm._s(_vm.FormMSG(247, "Distance known")))]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-row",
        [
          _vm.conditionForShowFromAddress
            ? _c(
                "b-col",
                { attrs: { sm: "12", md: "4", lg: "4", xl: "4" } },
                [
                  _vm.useAddressString === false
                    ? _c(
                        "b-form-group",
                        { attrs: { label: _vm.FormMSG(18, "From") } },
                        [
                          _c("v-address", {
                            attrs: {
                              params: {
                                title: _vm.FormMSG(
                                  48,
                                  "From address transport"
                                ),
                              },
                              "address-id": _vm.dataToSend.fromAddressId,
                              disabled: _vm.disableForms || _vm.disableAll,
                            },
                            on: {
                              change: _vm.handleChangeFromAddress,
                              delete: _vm.handleDeleteFromAddress,
                            },
                          }),
                        ],
                        1
                      )
                    : _c(
                        "b-form-group",
                        { attrs: { label: _vm.FormMSG(18, "From") } },
                        [
                          _c("b-form-input", {
                            staticClass: "bg-color-grams-hair",
                            attrs: {
                              value: _vm.coTwoData.fromAddress,
                              disabled: "",
                            },
                          }),
                        ],
                        1
                      ),
                ],
                1
              )
            : _vm._e(),
          _vm.conditionForShowToAddress
            ? _c(
                "b-col",
                { attrs: { sm: "12", md: "4", lg: "4", xl: "4" } },
                [
                  _vm.useAddressString === false
                    ? _c(
                        "b-form-group",
                        { attrs: { label: _vm.FormMSG(19, "To") } },
                        [
                          _c("v-address", {
                            attrs: {
                              params: {
                                title: _vm.FormMSG(58, "To address transport"),
                              },
                              "address-id": _vm.dataToSend.toAddressId,
                              disabled: _vm.disableForms || _vm.disableAll,
                            },
                            on: {
                              change: _vm.handleChangeToAddress,
                              delete: _vm.handleDeleteToAddress,
                            },
                          }),
                        ],
                        1
                      )
                    : _c(
                        "b-form-group",
                        { attrs: { label: _vm.FormMSG(19, "To") } },
                        [
                          _c("b-form-input", {
                            staticClass: "bg-color-grams-hair",
                            attrs: {
                              value: _vm.coTwoData.toAddress,
                              disabled: "",
                            },
                          }),
                        ],
                        1
                      ),
                ],
                1
              )
            : _vm._e(),
          _vm.hideDistance === false
            ? _c(
                "b-col",
                { attrs: { sm: "12", md: 4, lg: 4, xl: 4 } },
                [
                  _vm.$screen.width > 576 && _vm.typeMeasurement === 1
                    ? _c(
                        "b-form-group",
                        { attrs: { label: _vm.FormMSG(20, "Distance") } },
                        [
                          _c(
                            "b-input-group",
                            [
                              _c("b-form-input", {
                                class: {
                                  "bg-color-grams-hair":
                                    !_vm.dataToSend.distanceKnown,
                                },
                                attrs: {
                                  disabled:
                                    !_vm.dataToSend.distanceKnown ||
                                    _vm.disableForms ||
                                    _vm.disableAll,
                                },
                                on: { change: _vm.handleChangeDistance },
                                model: {
                                  value: _vm.dataToSend.km,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataToSend, "km", $$v)
                                  },
                                  expression: "dataToSend.km",
                                },
                              }),
                              _c(
                                "b-input-group-append",
                                [
                                  _c(
                                    "b-input-group-text",
                                    {
                                      staticClass:
                                        "bg-color-north-wind text-color-white",
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(_vm.distanceUnit) +
                                          "\n\t\t\t\t\t\t"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.$screen.width > 576 && _vm.typeMeasurement === 2
                    ? _c(
                        "b-form-group",
                        {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c("div", { staticClass: "d-flex" }, [
                                      _c("div", { staticClass: "mr-1" }, [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.FormMSG(
                                                1450,
                                                "Fuel consumption"
                                              )
                                            ) +
                                            "\n\t\t\t\t\t\t"
                                        ),
                                      ]),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            1398654910
                          ),
                        },
                        [
                          _c(
                            "b-input-group",
                            [
                              _c("b-form-input", {
                                attrs: {
                                  disabled: _vm.disableForms || _vm.disableAll,
                                },
                                on: { change: _vm.handleChangeFuelConsumption },
                                model: {
                                  value: _vm.dataToSend.fuelConsumption,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataToSend,
                                      "fuelConsumption",
                                      $$v
                                    )
                                  },
                                  expression: "dataToSend.fuelConsumption",
                                },
                              }),
                              _c(
                                "b-input-group-append",
                                [
                                  _c(
                                    "b-input-group-text",
                                    {
                                      staticClass:
                                        "bg-color-north-wind text-color-white",
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(_vm.FormMSG(1451, "L")) +
                                          "\n\t\t\t\t\t\t"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.$screen.width > 576 && _vm.typeMeasurement === 3
                    ? _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: _vm.FormMSG(1489, "Navigation duration"),
                          },
                        },
                        [
                          _c("input-date-time-picker", {
                            attrs: {
                              label: _vm.FormMSG(18, "Flight duration"),
                              uiid: "flightDuration",
                              type: "text",
                              placeholder: "hh:mm",
                              item: _vm.dataToSend.navigationDuration,
                              error: null,
                              nbHour: _vm.rangeHour[_vm.WORKTYPE.daily],
                              nbMinute: _vm.rangeMinute[_vm.WORKTYPE.daily],
                              fieldName: "number",
                              isEditable: () => !_vm.disableAll,
                              workType: _vm.WORKTYPE.daily,
                            },
                            on: { change: _vm.handleChangeNavigationDuration },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.$screen.width <= 576 && _vm.typeMeasurement === 1
                    ? _c("div", { staticClass: "d-flex mt-3" }, [
                        _c(
                          "div",
                          { staticClass: "w-90 mr-3" },
                          [
                            _c(
                              "b-form-group",
                              { attrs: { label: _vm.FormMSG(20, "Distance") } },
                              [
                                _c("b-form-input", {
                                  class: {
                                    "bg-color-grams-hair":
                                      !_vm.dataToSend.distanceKnown,
                                  },
                                  attrs: {
                                    disabled:
                                      !_vm.dataToSend.distanceKnown ||
                                      _vm.disableForms ||
                                      _vm.disableAll,
                                  },
                                  on: { change: _vm.handleChangeDistance },
                                  model: {
                                    value: _vm.dataToSend.km,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.dataToSend, "km", $$v)
                                    },
                                    expression: "dataToSend.km",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center pt-3 text-capitalize",
                          },
                          [
                            _c("div", { staticClass: "fs-20 fw-700" }, [
                              _vm._v(_vm._s(_vm.distanceUnit)),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm.$screen.width <= 576 && _vm.typeMeasurement === 2
                    ? _c("div", { staticClass: "d-flex mt-3" }, [
                        _c(
                          "div",
                          { staticClass: "w-90 mr-3" },
                          [
                            _c(
                              "b-form-group",
                              {
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _c("div", { staticClass: "d-flex" }, [
                                            _c("div", { staticClass: "mr-1" }, [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.FormMSG(
                                                      1450,
                                                      "Fuel consumption"
                                                    )
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t"
                                              ),
                                            ]),
                                            _vm.dataToSend.type === 1 ||
                                            _vm.dataToSend.type === 2
                                              ? _c(
                                                  "div",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "b-popover",
                                                        rawName:
                                                          "v-b-popover.hover.top",
                                                        value: _vm.FormMSG(
                                                          1993,
                                                          "The fuel consumption is not included for the Ferry transport type"
                                                        ),
                                                        expression:
                                                          "FormMSG(1993, 'The fuel consumption is not included for the Ferry transport type')",
                                                        modifiers: {
                                                          hover: true,
                                                          top: true,
                                                        },
                                                      },
                                                    ],
                                                    staticClass:
                                                      "text-color-tree-sap fw-600 cursor-pointer",
                                                    staticStyle: {
                                                      "margin-top": "-2px",
                                                    },
                                                    attrs: {
                                                      title: _vm.FormMSG(
                                                        1983,
                                                        "Info"
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      _vm.getLucideIcon(
                                                        "AlertTriangle"
                                                      ),
                                                      {
                                                        tag: "component",
                                                        attrs: { size: 16 },
                                                      }
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  1704503518
                                ),
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    disabled:
                                      _vm.disableForms ||
                                      _vm.disableAll ||
                                      _vm.dataToSend.type === 1 ||
                                      _vm.dataToSend.type === 2,
                                  },
                                  on: {
                                    change: _vm.handleChangeFuelConsumption,
                                  },
                                  model: {
                                    value: _vm.dataToSend.fuelConsumption,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.dataToSend,
                                        "fuelConsumption",
                                        $$v
                                      )
                                    },
                                    expression: "dataToSend.fuelConsumption",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center pt-3 text-capitalize",
                          },
                          [
                            _c("div", { staticClass: "fs-20 fw-700" }, [
                              _vm._v(_vm._s(_vm.FormMSG(1451, "L"))),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm.$screen.width <= 576 && _vm.typeMeasurement === 3
                    ? _c("div", { staticClass: "d-flex mt-3" }, [
                        _c(
                          "div",
                          { staticClass: "w-90 mr-3" },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: _vm.FormMSG(
                                    1489,
                                    "Navigation duration"
                                  ),
                                },
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    disabled:
                                      _vm.disableForms || _vm.disableAll,
                                  },
                                  on: {
                                    change: _vm.handleChangeFuelConsumption,
                                  },
                                  model: {
                                    value: _vm.dataToSend.navigationDuration,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.dataToSend,
                                        "navigationDuration",
                                        $$v
                                      )
                                    },
                                    expression: "dataToSend.navigationDuration",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center pt-3 text-capitalize",
                          },
                          [
                            _c("div", { staticClass: "fs-20 fw-700" }, [
                              _vm._v(_vm._s(_vm.FormMSG(1451, "L"))),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          [9, 10, 11, 12, 19].includes(_vm.transportTypeMapped)
            ? _c(
                "b-col",
                { attrs: { sm: "12", md: "4", lg: "4", xl: "4" } },
                [
                  _vm.$screen.width > 576
                    ? _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: _vm.FormMSG(
                              21,
                              "Material weight (if Freight)"
                            ),
                          },
                        },
                        [
                          _c(
                            "b-input-group",
                            [
                              _c("b-form-input", {
                                attrs: {
                                  disabled: _vm.disableForms || _vm.disableAll,
                                  state:
                                    _vm.getStateValidationField(
                                      "dataToSend.number"
                                    ),
                                },
                                on: { change: _vm.handleChangeMaterialWeight },
                                model: {
                                  value: _vm.$v.dataToSend.number.$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.dataToSend.number,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.dataToSend.number.$model",
                                },
                              }),
                              _c(
                                "b-input-group-append",
                                [
                                  _c(
                                    "b-input-group-text",
                                    {
                                      staticClass:
                                        "bg-color-north-wind text-color-white",
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(_vm.FormMSG(29, "kg")) +
                                          "\n\t\t\t\t\t\t"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.$v.dataToSend.number.$error &&
                          _vm.getStateValidationField("dataToSend.number") !==
                            null
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.FormMSG(
                                        874,
                                        "Please enter material weight"
                                      )
                                    ) +
                                    "\n\t\t\t\t"
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      )
                    : _c("div", { staticClass: "d-flex mt-3" }, [
                        _c(
                          "div",
                          { staticClass: "w-90 mr-3" },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: _vm.FormMSG(
                                    21,
                                    "Material weight (if Freight)"
                                  ),
                                },
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    disabled:
                                      _vm.disableForms || _vm.disableAll,
                                    state:
                                      _vm.getStateValidationField(
                                        "dataToSend.number"
                                      ),
                                  },
                                  on: {
                                    change: _vm.handleChangeMaterialWeight,
                                  },
                                  model: {
                                    value: _vm.$v.dataToSend.number.$model,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.$v.dataToSend.number,
                                        "$model",
                                        $$v
                                      )
                                    },
                                    expression: "$v.dataToSend.number.$model",
                                  },
                                }),
                                _vm.$v.dataToSend.number.$error &&
                                _vm.getStateValidationField(
                                  "dataToSend.number"
                                ) !== null
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.FormMSG(
                                                874,
                                                "Please enter material weight"
                                              )
                                            ) +
                                            "\n\t\t\t\t\t\t"
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center pt-3 text-capitalize",
                          },
                          [
                            _c("div", { staticClass: "fs-20 fw-700" }, [
                              _vm._v(_vm._s(_vm.FormMSG(29, "kg"))),
                            ]),
                          ]
                        ),
                      ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }